<template>
  <div class="virtual-time-root" @click='reload'>
    <div class="year">{{ year }} <small>年</small></div>
    <div class="month">{{ month }} <small>月</small></div>
  </div>
</template>

<script>
export default {
  name: 'VirtualTime',
  computed: {
    year() {
      return this.$store.state.game.virtualTime.year;
    },
    month() {
      return this.$store.state.game.virtualTime.month;
    },
  },
  methods: {
    reload() {
      const reloadOk = confirm('リロードしますか？')
      if (reloadOk) location.reload();
    },
  }
};
</script>

<style lang="scss" scoped>
.virtual-time-root {
  z-index: 100;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);
  padding: 0.2rem 1rem;
  font-weight: bold;

  .year {
    font-size: 0.8rem;
  }

  .month {
    font-size: 1.2rem;
  }

  small {
    font-size: 0.8rem;
    font-weight: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/VirtualTime.vue